import EFTB from '@images/banner/1_KV iMedical Card Elite 6000px 1480px EN.svg';
import EFTB_Mobile from '@images/banner/mobile/1_KV iMedical Card Elite 390px 430px EN.jpg';
import ELIB from '@images/banner/EzyMedical ENG - Homepage Banner (EDP).png';
import ELIB_Mobile from '@images/banner/mobile/EzyMedical ENG - Mobile Banner (EDP).png';

export default {
  banner: {
    'iMedical-card-elite': {
      headline: 'i-MedicalCard Elite',
      subheadline:
        'When it comes to health, Etiqa i-MedicalCard Elite plan is here to offer you only the best. Experience top-tier coverage at an affordable price whether you’re young, old or anywhere in between. Let us provide the peace of mind you deserve.',
      productLink:
        'https://www.etiqa.com.my/v2/health-insurance-takaful/imedicalcardelite',
      image: {
        desktop: EFTB,
        mobile: EFTB_Mobile,
      },
    },
    'ezy-medical': {
      headline: 'Your mental wellbeing should be a no-brainer',
      subheadline:
        'A comprehensive medical plan that goes beyond hospitalisation and surgery, including outpatient psychiatrist consultation and treatment.',
      productLink:
        'https://www.etiqa.com.my/v2/health-insurance-takaful/ezymedical',
      image: {
        desktop: ELIB,
        mobile: ELIB_Mobile,
      },
    },
    'easy-health': {
      headline: 'EasyHealth First',
      subheadline:
        'Discover our standalone medical plan designed to provide comprehensive hospital and surgical benefits. This plan also includes coverage for outpatient psychiatric consultation and treatment, ensuring holistic care for your mental and physical health needs.',
      productLink: '#',
      image: {
        desktop: ELIB,
        mobile: ELIB_Mobile,
      },
    },
    clickHere: '<a>Click here</a> for more details.',
  },
  downloadDocuments: {
    title: 'Download Documents',
    'ezy-medical': {
      Brochure: 'Brochure',
      'Product Disclosure Sheet (PDS)': 'Product Disclosure Sheet (PDS)',
      'Policy Contract': 'Policy Contract',
      FAQ: 'FAQ',
      'Annual Premium Rate Table': 'Annual Premium Rate Table',
      'Premium Refund Table': 'Premium Refund Table',
    },
    'easy-health': {
      Brochure: 'Brochure',
      'Product Disclosure Sheet (PDS)': 'Product Disclosure Sheet (PDS)',
      'Policy Contract': 'Policy Contract',
      FAQ: 'FAQ',
      'Annual Premium Rate Table': 'Annual Premium Rate Table',
      'Premium Refund Table': 'Premium Refund Table',
    },
  },
  keyBenefits: 'Key Benefits',
  productKeyBenefits: {
    'iMedical-card-elite': {
      lifeTime: {
        title: 'Unlimited Lifetime Medical Coverage',
        description:
          'Get unlimited lifetime medical coverage with a high annual limit of up to RM250,000.',
      },
      dengue: {
        title: 'Dengue Fever Treatment Charges',
        description:
          'Get coverage for outpatient dengue fever treatment charges including consultation, examination tests and medication of up to RM2,000.',
      },
      healthCare: {
        title: 'Accessible Healthcare Services via the Etiqa+ App',
        description:
          'Navigate to the nearest Etiqa Panel Hospitals using the built in GPS, view your medical care entitlements, request Guarantee Letters, check your medical coverage balance, enjoy a smoother hospitalisation process and more.',
      },
      easyApplication: {
        title: 'Affordable Contribution',
        description: 'Get coverage of RM250,000 from as low as RM2.36 a day.',
      },
    },
    'ezy-medical': {
      lifeTime: {
        title: 'Unlimited Lifetime Medical Coverage',
        description:
          'Get unlimited lifetime medical coverage with a high annual limit of up to RM350,000.',
      },
      charges: {
        title: 'Outpatient Psychiatrist Consultation and Treatment Charges',
        description:
          'Take control of your mental health with coverage for the following conditions: major depressive disorder, obsessive compulsive disorder, bipolar disorder or post-traumatic stress disorder and more.',
      },
      cashless: {
        title: 'Cashless Hospital Admission',
        description:
          'Guarantee Letters provided with just one tap away via the Etiqa+ app.',
      },
      affordable: {
        title: 'Affordable Premium',
        description:
          'Get coverage of up to RM350,000 from as low as RM2.76 a day.',
      },
    },
    'easy-health': {
      lifeTime: {
        title: 'Unlimited Lifetime Coverage',
        description:
          'No overall lifetime limit with a high annual limit of up to RM350,000.',
      },
      extensive: {
        title: 'Extensive Health Coverage',
        description:
          'Includes inpatient and day care surgery benefits, and outpatient benefits covering psychiatric, cancer, and dialysis treatments.',
      },
      cashless: {
        title: 'Cashless Hospital Admission',
        description:
          'Enjoy cashless hospital admission with the Etiqa+ app, which helps you find the nearest hospital and obtain a guarantee letter effortlessly.',
      },
      easyApplication: {
        title: 'Easy Application',
        description:
          'Instant approval with no medical examination required. Coverage is up to 85 years old.',
      },
    },
  },
  forms: {
    quotationForm: {
      title: 'Myself',
      name: 'Name',
      male: 'Male',
      female: 'Female',
      nric: 'NRIC',
      kidNric: 'NRIC/MyKid',
      occupation: 'Occupation',
      email: 'Email',
      placeholder: {
        name: 'Enter your full name',
        nric: 'Enter NRIC number',
        occupation: 'Select occupation',
        email: 'Enter email address',
      },
      button: 'Proceed',
    },
    memberForm: {
      ' Please provide the following details to proceed with the application.':
        ' Please provide the following details to proceed with the application.',
      'You may proceed with their application separately.':
        'You may proceed with their application separately.',
      isBelow:
        'Parent/guardian information required for members below 16 years old.',
      forSpouse: {
        takaful:
          'Certificate owner information required for protect your spouse.',
        insurance: 'Policy owner information required for protect your spouse.',
      },
      isAbove:
        'For child aged 16 and above, a separate protection plan is required.',
    },
  },
  button: {
    'Get Quote': 'Get Quote',
    Verify: 'Verify',
    'No, try again': 'No, try again',
    'Yes, This Is me': 'Yes, This Is me',
  },
  'I am': 'I am',
  'I would like to protect my': 'I would like to protect my',
  'Valid for Malaysian citizen only':
    'Valid for Malaysian citizen only, for Non-Malaysian please contact <email>info@etiqa.com.my</email>. ',
  'Get a Free Quotation in Minutes': 'Get a Free Quotation in Minutes',
  'Ensure these criteria are met to proceed':
    'Ensure these criteria are met to proceed:',
  'You are a Malaysian citizen.': 'You are a <1>Malaysian citizen</1>.',
  'Your age is between 17 to 55 years old to purchase as an adult.':
    'Your age is between <1>17 to 55 years old</1> to purchase as an <1>adult</1>.',
  agentForm: {
    'This plan is designated for agent only':
      'This plan is designated for agent only',
    'Log in with my agent code': 'Log in with my agent code',
    agentCode: 'Agent code',
    welcome: 'Welcome {{agentName}}.',
    'Is this your agent account?': 'Is this your agent account?',
    placeholder: {
      agentCode: 'Example: kei00020',
    },
  },
  coverageNeeds: {
    unsure: 'Unsure About Your Coverage Needs?',
    checkCalculator:
      'Make sure to check <b>Analysis and Financial Budget Calculator</b> to determine your coverage',
    checkItOut: 'Check it out',
    link: 'https://www.mycoverage.my/en/calculator/term_coverage/',
  },
  affiliate: {
    agentCode: 'Agent Code',
    agentBranch: 'Agent Branch',
  },
};
